import { z } from 'zod'
import { CountryCode } from 'libphonenumber-js'

import i18n from '@src/i18n/i18n'
import { isValidPhoneNumber } from '@src/utils/isValidPhoneNumber'

const t = (key: string) => i18n.t(key, { ns: 'signUp' })

export const newUserSchema = (countryCode: CountryCode) =>
  z
    .object({
      firstName: z
        .string({ required_error: t('first_name.validation.required_error') })
        .min(2, {
          message: t('first_name.validation.minimum_required_characters'),
        }),
      lastName: z
        .string({
          required_error: t('last_name.validation.required_error'),
        })
        .min(2, {
          message: t('last_name.validation.minimum_required_characters'),
        }),
      phoneNumber: z
        .string({
          required_error: t('phone_number.validation.required_error'),
          invalid_type_error: t('phone_number.validation.invalid_type_error'),
        })
        .refine(
          val => isValidPhoneNumber(val, countryCode),
          t('phone_number.validation.invalid_type_error')
        ),
      password: z
        .string({ required_error: t('password.validation.required_error') })
        .min(8, {
          message: t('password.validation.minimum_required_characters'),
        })
        .refine(
          value => {
            if (!value) return false
            const hasUpperCase = /[A-Z]/.test(value)
            const hasLowerCase = /[a-z]/.test(value)
            const hasNumber = /[0-9]/.test(value)
            return hasUpperCase && hasLowerCase && hasNumber
          },
          {
            message: t('password.validation.password_complexity_requirements'),
          }
        ),
      passwordConfirm: z.string({
        required_error: t('confirm_password.validation.required_error'),
        invalid_type_error: t('confirm_password.validation.invalid_type_error'),
      }),
      email: z
        .string({
          required_error: t('email_address.validation.required_error'),
          invalid_type_error: t('email_address.validation.invalid_type_error'),
        })
        .email(),
    })
    .refine(
      ({ password, passwordConfirm }) => {
        // timing safe is not necessary here as this is frontend
        return password === passwordConfirm
      },
      {
        message: t('confirm_password.validation.passwords_do_not_match'),
        path: ['passwordConfirm'],
      }
    )
